import { createAction, props } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from '../../../common/action-namespace';
import { EmailConversation } from 'common/store/genesys-cloud/conversations/emails/models/email-conversation.model';
import {
  ConversationActionCreator,
  ConversationsActionCreator
} from 'common/store/genesys-cloud/conversations/common/models/conversation-action.model';
import { WrapUpCode } from '../../common/models/wrap-up-code.model';

export const withNameSpace = withGenesysCloudStoreNameSpace('Email conversations');

export const initializeModule = createAction(withNameSpace('Initialize module'));

export const loadEmailConversations = createAction(withNameSpace('Load email conversations'));

export const emailConversationsLoaded: ConversationsActionCreator<EmailConversation> = createAction(
  withNameSpace('Email conversations loaded'),
  props<{ conversations: EmailConversation[] }>()
);

export const emailConversationChanged: ConversationActionCreator<EmailConversation> = createAction(
  withNameSpace('Email conversation changed'),
  props<{ conversation: EmailConversation }>()
);

export const acceptEmailConversation = createAction(
  withNameSpace('Accept email conversation'),
  props<{ conversationId: string; focus: boolean }>()
);

export const closeEmailConversation = createAction(
  withNameSpace('Close email conversation'),
  props<{ conversationId: string }>()
);

export const skipWrapUpForEmailConversation = createAction(
  withNameSpace('Skip wrap-up for email conversation'),
  props<{ conversationId: string }>()
);

export const loadWrapUpsForEmailConversation = createAction(
  withNameSpace('Load wrap-ups for email conversation'),
  props<{ conversationId: string }>()
);

export const wrapUpsLoadedForEmailConversation = createAction(
  withNameSpace('Wrap-ups loaded for email conversation'),
  props<{ conversationId: string; wrapUpCodes: WrapUpCode[] }>()
);

export const saveWrapUpForEmailConversation = createAction(
  withNameSpace('Save wrap up for email conversation'),
  props<{ conversationId: string; wrapUpCode: string }>()
);

export const evictEmailConversation = createAction(
  withNameSpace('Evict email conversation'),
  props<{ conversationId: string }>()
);

export const transferEmailConversationToUser = createAction(
  withNameSpace('Transfer Email Conversation to User'),
  props<{ conversationId: string; participantId: string; userId: string }>()
);

export const transferEmailConversationToQueue = createAction(
  withNameSpace('Transfer Email Conversation to Queue'),
  props<{ conversationId: string; participantId: string; queueId: string }>()
);

export const createEmailConversation = createAction(
  withNameSpace('Create Email Conversation'),
  props<{ queueId: string; toAddress: string }>()
);

export const createEmailConversationSuccess = createAction(
  withNameSpace('Create Email Conversation Success'),
  props<{ conversationId: string }>()
);

export const createEmailConversationFailure = createAction(
  withNameSpace('Create Email Conversation Failure'),
  props<{ message: string }>()
);

export const transferEmailConversationSuccess = createAction(
  withNameSpace('Transfer Email Conversation Success'),
  props<{ conversationId: string }>()
);

export const transferEmailConversationFailure = createAction(
  withNameSpace('Transfer Email Conversation Failure'),
  props<{ conversationId: string }>()
);
